<template>
    <div>
        <!-- Preloader -->
        <PagePreloader v-if="!pageIsLoaded"></PagePreloader>

        <!-- Content -->
        <div class="row">
            <!--begin::Aside-->
            <div class="col-xl-3 gutter-b">
                <!--begin::Profile Card-->
                <div class="card card-custom">
                    <div class="card-header py-3">
                        <div class="card-title align-items-start flex-column">
                            <h3 class="card-label font-weight-bolder text-dark">Admin Tools</h3>
                            <span class="text-muted font-weight-bold font-size-sm mt-1"
                                >Manage Hashtastic Settings</span
                            >
                        </div>
                    </div>
                    <!--begin::Body-->
                    <div class="card-body pt-4">
                        <!--begin::Nav-->
                        <div class="navi navi-bold navi-hover navi-active navi-link-rounded py-2">
                            <!-- NOTE - Free trial -->
                            <div class="navi-item mb-2">
                                <a
                                    @click="setPanel('free-trial')"
                                    class="navi-link py-4"
                                    :class="currentPanel == 'free-trial' ? 'active' : ''"
                                >
                                    <span class="navi-icon mr-2">
                                        <span class="svg-icon">
                                            <inline-svg
                                                src="/media/svg/icons/General/User.svg"
                                            ></inline-svg>
                                        </span>
                                    </span>
                                    <span class="navi-text font-size-lg"> Create free trial </span>
                                </a>
                            </div>
                            <!-- NOTE - Change password -->
                            <div class="navi-item mb-2">
                                <a
                                    @click="setPanel('password')"
                                    class="navi-link py-4"
                                    :class="currentPanel == 'password' ? 'active' : ''"
                                >
                                    <span class="navi-icon mr-2">
                                        <span class="svg-icon">
                                            <inline-svg
                                                src="/media/svg/icons/Communication/Shield-user.svg"
                                            ></inline-svg>
                                        </span>
                                    </span>
                                    <span class="navi-text font-size-lg"> XXX </span>
                                </a>
                            </div>
                        </div>
                        <!--end::Nav-->
                    </div>
                    <!--end::Body-->
                </div>
                <!--end::Profile Card-->
            </div>
            <!--end::Aside-->

            <transition-group name="fade-in-up" tag="div" class="col-xl-9">
                <!-- NOTE - PASSWORD CHANGE -->
                <div v-if="currentPanel == 'free-trial'" key="2">
                    <!--begin::Card-->
                    <div class="card card-custom">
                        <!--begin::Header-->
                        <div class="card-header py-3">
                            <div class="card-title align-items-start flex-column">
                                <h3 class="card-label font-weight-bolder text-dark">Free trial</h3>
                                <span class="text-muted font-weight-bold font-size-sm mt-1"
                                    >Add Hashtastic Premium to an account</span
                                >
                            </div>
                            <div class="card-toolbar">
                                <button
                                    type="reset"
                                    class="btn btn-success mr-2"
                                    @click="addFreeTrial"
                                    :disabled="formIsLoading"
                                >
                                    Start trial
                                </button>
                                <button
                                    type="reset"
                                    class="btn btn-secondary"
                                    @click="cancelFreeTrial"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                        <!--end::Header-->

                        <!-- Preloader -->
                        <PagePreloader v-if="formIsLoading" class="gutter-t"></PagePreloader>

                        <!-- Error management -->
                        <CustomAlerts :errors="errors" class="gutter-t col"></CustomAlerts>

                        <!--begin::Form-->
                        <form class="form" method="POST" v-on:submit.prevent="addFreeTrial">
                            <div class="card-body">
                                <!-- NOTE - User ID input -->
                                <b-form-group label-cols="4" label-cols-lg="2" label="Input ID">
                                    <div
                                        :class="
                                            userSearchIsLoading
                                                ? 'spinner spinner-primary spinner-right'
                                                : ''
                                        "
                                    >
                                        <b-form-input
                                            placeholder="Enter your product ID here"
                                            v-model="formfreetrial.userid"
                                            @input="getUsernameFromId()"
                                        ></b-form-input>
                                        <div class="valid-feedback" v-if="freetrialfeedback.valid">
                                            Success! Found username
                                            <strong>{{ formfreetrial.foundUsername }}</strong>
                                        </div>
                                        <div
                                            class="invalid-feedback"
                                            v-if="freetrialfeedback.invalid"
                                        >
                                            Couldn't find any account with that user ID
                                        </div>
                                    </div>
                                </b-form-group>
                                <!-- NOTE - Type selection -->
                                <b-form-group label-cols="4" label-cols-lg="2" label="Type">
                                    <!-- <label>Search Mode</label> -->
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <label class="option option-plain">
                                                <span class="option-control">
                                                    <span class="radio">
                                                        <input
                                                            type="radio"
                                                            name="mode"
                                                            value="1"
                                                            checked="checked"
                                                            v-model="formfreetrial.type"
                                                        />
                                                        <span></span>
                                                    </span>
                                                </span>
                                                <span class="option-label">
                                                    <span class="option-head">
                                                        <span class="option-title">
                                                            Unlimited Hashtastic
                                                        </span>
                                                        <span class="option-focus"> </span>
                                                    </span>
                                                    <span class="option-body">
                                                        Adds two years starting yesterday
                                                    </span>
                                                </span>
                                            </label>
                                        </div>

                                        <div class="col-lg-6">
                                            <label class="option option-plain">
                                                <span class="option-control">
                                                    <span class="radio">
                                                        <input
                                                            type="radio"
                                                            name="mode"
                                                            value="2"
                                                            v-model="formfreetrial.type"
                                                        />
                                                        <span></span>
                                                    </span>
                                                </span>
                                                <span class="option-label">
                                                    <span class="option-head">
                                                        <span class="option-title">
                                                            One week trial
                                                        </span>
                                                        <span class="option-focus"> </span>
                                                    </span>
                                                    <span class="option-body">
                                                        Adds one month 3 weeks ago
                                                    </span>
                                                </span>
                                            </label>
                                        </div>

                                        <div class="col-lg-6">
                                            <label class="option option-plain">
                                                <span class="option-control">
                                                    <span class="radio">
                                                        <input
                                                            type="radio"
                                                            name="mode"
                                                            value="3"
                                                            v-model="formfreetrial.type"
                                                        />
                                                        <span></span>
                                                    </span>
                                                </span>
                                                <span class="option-label">
                                                    <span class="option-head">
                                                        <span class="option-title">
                                                            3 day trial
                                                        </span>
                                                        <span class="option-focus"> </span>
                                                    </span>
                                                    <span class="option-body">
                                                        Adds one month 27 days ago
                                                    </span>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </b-form-group>
                                <b-form-group label-cols="4" label-cols-lg="2" label="Campaigns">
                                    <b-form-input
                                        type="number"
                                        placeholder="How many campaigns?"
                                        v-model="formfreetrial.campaigns"
                                        class="w-100"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <input type="submit" class="d-none" :disabled="formIsLoading" />
                        </form>
                        <!--end::Form-->
                    </div>
                </div>
                <!--end::Password Change-->
            </transition-group>
        </div>
        <!-- End::row -->
    </div>
</template>

<style lang="scss" scoped>
@import "~bootstrap-vue/dist/bootstrap-vue.css";
.navi-link {
    cursor: pointer;
}
</style>
<style scoped>
.valid-feedback,
.invalid-feedback {
    display: block !important;
}
.list-enter-active,
.list-leave-active,
.list-move {
    transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
    transition-property: opacity, transform;
}

.list-enter {
    opacity: 0;
    transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
    opacity: 1;
    transform: translateX(0) scaleY(1);
}

.list-leave-active {
    position: absolute;
}

.list-leave-to {
    opacity: 0;
    transform: scaleY(0);
    transform-origin: center top;
}
</style>

<style lang="scss" scoped>
@import "~bootstrap-vue/dist/bootstrap-vue.css";
</style>

<script>
// Defaults
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapGetters } from "vuex";
import axios from "axios";
// Components
import PagePreloader from "@/view/content/Custom/PagePreloader.vue";
import CustomAlerts from "@/view/content/Custom/CustomAlerts.vue";
// Mixins
import axiosErrorManagement from "@/mixins/axiosErrorManagement";

export default {
    name: "EnginesPage",
    mixins: [axiosErrorManagement],
    components: {
        PagePreloader,
        CustomAlerts,
    },
    data() {
        return {
            // Preloaders
            pageIsLoaded: true,
            formIsLoading: false,
            userSearchIsLoading: false,

            // Errors
            errors: [],

            // Debouncer
            timeout: 0,

            // Displayers
            currentPanel: "free-trial",

            // Forms
            formfreetrial: {
                userid: "",
                foundUsername: "",
                type: 1,
                campaigns: 1,
            },
            freetrialfeedback: {
                valid: false,
                invalid: false,
            },
        };
    },
    methods: {
        // Get username from ID
        getUsernameFromId() {
            // Hide the feedback
            this.freetrialfeedback.valid = false;
            this.freetrialfeedback.invalid = false;

            // Reset found username
            this.formfreetrial.foundUsername = "";

            // Only perform if length > 0
            if (this.formfreetrial.userid.length > 0) {
                // Debounce the query so we don't spam the server
                if (this.timeout) clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    // TODO - Defaults & loaders
                    this.userSearchIsLoading = true;

                    // Perform axios
                    axios
                        .post("admin/getusernamefromid", {
                            id: this.formfreetrial.userid,
                        })
                        .then((response) => {
                            // Make pretty
                            var data = response.data;

                            // Check status
                            if (data.status == "OK") {
                                this.freetrialfeedback.valid = true;
                                this.formfreetrial.foundUsername = data.data.username;
                            } else {
                                this.freetrialfeedback.invalid = true;
                            }
                        })
                        .catch((error) => {
                            this.errors.push(this.handleAxiosErrors(error));
                        })
                        .finally(() => {
                            // Reset loader
                            this.userSearchIsLoading = false;
                        });
                }, 500);
                // If no length then cancel out
            } else {
                clearTimeout(this.timeout);
            }
        },
        // Create free trial
        addFreeTrial() {
            // Start loader
            this.formIsLoading = true;

            // Reset errors
            this.errors = [];

            // Perform post
            axios
                .post("admin/createfreetrial", {
                    userid: this.formfreetrial.userid,
                    type: this.formfreetrial.type,
                    campaigns: this.formfreetrial.campaigns,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    console.log(data);

                    // Get success
                    if (data.status == "OK") {
                        // Reset all fields
                        this.cancelFreeTrial();
                    }

                    // Error management
                    if (data.messages.length > 0) {
                        data.messages.forEach((item) => {
                            this.errors.push({ type: item.type, message: item.message });
                        });
                    }
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Reset loader
                    this.formIsLoading = false;
                });
        },

        // Empty the free trial form
        cancelFreeTrial() {
            // Reset all data
            this.formfreetrial.userid = "";
            this.formfreetrial.foundUsername = false;
            this.formfreetrial.username = "";
            this.formfreetrial.type = 1;
            this.formfreetrial.campaigns = 1;
            this.freetrialfeedback.valid = false;
            this.freetrialfeedback.invalid = false;
        },

        // setPanel
        setPanel(panel) {
            // Reset errors if we're switching panels
            if (this.currentPanel != panel) {
                this.errors = [];
            }
            // Reset loader
            this.formIsLoading = false;
            // Set panel
            this.currentPanel = panel;
        },

        // Check the user is an admin
        checkAdmin() {
            if (!this.isAdmin) {
                this.$router.push({
                    name: "dashboard",
                    params: {
                        propFlashMessages: [
                            {
                                type: "danger",
                                message: "You aren't authorized to access this area.",
                            },
                        ],
                    },
                });
            }
        },
    },

    mounted() {
        // Check if we're admin
        this.checkAdmin();

        // Set breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [{ title: "Tools", route: "admin-tools" }]);
    },

    computed: {
        ...mapGetters({ currentUser: "auth/currentUser", isAdmin: "auth/isAdmin" }),
    },
};
</script>
